/**
 * A YouTube URL -> its poster image.
 *
 * The trailer card needs artwork and a Drop stores only `trailerUrl`. YouTube
 * publishes a still for every video at a stable path, so the thumbnail is
 * DERIVED from the id rather than being a second field an operator has to fill
 * in and keep in sync with the video beside it.
 *
 * `hqdefault` rather than `maxresdefault`: the max-res still does not exist for
 * every video and 404s when it does not, which would leave the card's artwork
 * blank for no reason a viewer could act on. `hqdefault` is always present.
 */

/**
 * Every URL shape YouTube hands out.
 *
 * `/shorts/` is not optional: an operator pasting a Short got no id, so no
 * still, so no card at all — the video was authored and simply never appeared,
 * with nothing on screen to say why.
 */
const PATTERNS = [
    /[?&]v=([\w-]{11})/,
    /youtu\.be\/([\w-]{11})/,
    /youtube\.com\/embed\/([\w-]{11})/,
    /youtube\.com\/shorts\/([\w-]{11})/,
];

export function youTubeId(url?: string): string | undefined {
    if (!url) return undefined;
    for (const p of PATTERNS) {
        const m = url.match(p);
        if (m) return m[1];
    }
    return undefined;
}

export function youTubeThumb(url?: string): string | undefined {
    const id = youTubeId(url);
    return id ? `https://i.ytimg.com/vi/${id}/hqdefault.jpg` : undefined;
}
